exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".form-delete-restore .description-block {\n  padding-bottom: 20px; }\n\n.form-delete-restore .form-block {\n  margin-top: 0px; }\n\n.form-delete-restore .form-action {\n  float: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/common-ops/delete-restore/delete-restore.scss
// module id = Q8Fc
// module chunks = 0